export default __webpack_public_path__ + "static/green-motion-phone-f371637a0f7dd3c91fca9df1de575b4f.png";